import {
    Configuration,
    EntityRoute
  } from '../../../../../core';

  export const entityRoute = {
    addText: 'Crear ruta',
    export: false,
    checkbox: false,
    disabled: false,
    paginator: true,
    partialField: '',
    columns: [
      {
        title: 'Empresa',
        name: 'company',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: EntityRoute) => element.origin.companyCode
      },
      {
        title: 'Origen',
        name: 'origin',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: EntityRoute) => element.origin.entityName
      },
      {
        title: 'Destino',
        name: 'destiny',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: EntityRoute) => element.destiny.entityName
      },
      {
        title: 'Tipos de despacho',
        name: 'dispatchTypes',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: EntityRoute) => {
          if (element.dispatchTypes.length && element.dispatchTypes[0].name) {
            return element.dispatchTypes
              .map(
                dispatchType =>
                  dispatchType.name +
                  (dispatchType.time >= 0 ? ' ( ' + dispatchType.time + 'd )' : '')
              )
              .join(' / ');
          } else {
            return '';
          }
        }
      },
      {
        title: 'Activo',
        name: 'active',
        type: 'boolean',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: Configuration) => element.active
      }
    ],
    subTable: {}
  };
